import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/Card";
import { Input } from "@/components/ui/Input";
import { Button } from "@/components/ui/Button";

const MIN_LEN = 10;

export default function ResetPassword() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";

  const [password, setPassword] = useState("");
  const [conferma, setConferma] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function submit(ev: React.FormEvent) {
    ev.preventDefault();
    if (password !== conferma) {
      setError("Le due password non coincidono");
      return;
    }
    setSending(true); setError(null);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => nav("/admin", { replace: true }), 2500);
    } catch (e: any) {
      setError(e.message ?? "Errore durante il reset");
    } finally {
      setSending(false);
    }
  }

  // Link aperto senza token (o troncato dal client email).
  if (!token) {
    return (
      <Shell titolo="Link non valido">
        <p className="text-secondary text-sm leading-relaxed">
          Questo link non è completo. Richiedi un nuovo link di reset dalla
          pagina di login.
        </p>
        <Link to="/admin" className="text-accent font-mono text-sm">
          ← Torna al login
        </Link>
      </Shell>
    );
  }

  if (done) {
    return (
      <Shell titolo="Password aggiornata">
        <p className="text-secondary text-sm leading-relaxed">
          La tua password è stata cambiata. Ti stiamo riportando al login…
        </p>
        <Link to="/admin" className="text-accent font-mono text-sm">
          → Vai al login
        </Link>
      </Shell>
    );
  }

  return (
    <Shell titolo="Nuova password">
      <form onSubmit={submit} className="space-y-4">
        <Input
          label="Nuova password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          minLength={MIN_LEN}
          required
          autoFocus
        />
        <Input
          label="Conferma password"
          type="password"
          value={conferma}
          onChange={(e) => setConferma(e.target.value)}
          minLength={MIN_LEN}
          required
        />
        <p className="text-xs font-mono text-muted">
          Almeno {MIN_LEN} caratteri.
        </p>

        {error && (
          <div className="bg-red-500/10 border border-red-500/40 rounded-xl p-3 text-sm text-red-300">
            {error}
          </div>
        )}

        <Button type="submit" loading={sending} className="w-full">
          Salva password
        </Button>
      </form>
    </Shell>
  );
}

function Shell({ titolo, children }: { titolo: string; children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <Card className="max-w-md w-full space-y-5">
        <header className="space-y-1">
          <div className="font-mono text-xs uppercase tracking-wider text-secondary">
            Area docente
          </div>
          <h1 className="text-3xl font-serif text-primary">{titolo}</h1>
        </header>
        {children}
      </Card>
    </div>
  );
}
